require("./app/bootstrap");

// Vue Components

// React Components
require("./components/react/signup-form/signup-form");

require("./twilio-chat");

import Intercom from "@intercom/messenger-js-sdk";

if(window.app.webchat === 'intercom') {
    // Initialize Intercom
    const userData = JSON.parse(user);
    Intercom({
        app_id: window.intercom_app_id,
        user_id: userData.id,
        name: userData.full_name,
        email: userData.email,
        created_at: userData.created_at,
        external_id: `user-${userData.id}`,
        "Nova URL": `${window.app.url}/nova/resources/users/${userData.id}`,
    });
}
